module.exports = __webpack_public_path__ + "static/media/ic-close.c4c396d3.svg";